import { usePathname } from 'wouter/use-browser-location';

const Footer = () => {
  const path = usePathname();
  const isMeme = path.includes('/trading-meme') || path.includes('/meme');

  return (
    <div className="bg-[#13141D] text-[#84869A] font-medium md:text-[14px] text-[12px] py-4 flex justify-center items-center px-3">
      <div className="flex md:justify-between items-center w-full max-w-[1216px] flex-col md:flex-row justify-center gap-3">
        <div>
          © {new Date().getFullYear()} Agents.Land &#x2022; All rights reserved
        </div>
        <div className="md:text-right text-center">
          {isMeme ? (
            <span className="flex items-center text-[#A382FF]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.66683 1.99805H5.3335V3.33105H4.00016V4.66439H5.3335V3.33138H6.66667V4.66439H8V3.33105H6.66683V1.99805ZM8.00016 12.6647V13.998H6.66683V12.6647H8.00016ZM9.33366 12.665V11.3317H8.00033V12.665H9.33366ZM8.00016 9.99772V11.3311H6.66683V9.99772L5.33366 9.99772V7.33105H6.66683V5.99805H8.00016V4.66504H9.33366V3.33105H12.0003V5.99772H10.6668V7.33171L9.3335 7.33171V8.66471H8.00033V9.99772L8.00016 9.99772ZM10.6668 7.33171H12.0002V8.66471H13.3333V7.33171H14.6667V8.66504H13.3335V9.99805H12.0002V8.66504H10.6668V7.33171ZM1.3335 9.99805H2.66667V11.3311H4V9.99772H2.66683V8.66471H1.3335V9.99805ZM5.3335 9.99805H4.00016V8.66471H5.3335V9.99805Z"
                  fill="#A382FF"
                />
              </svg>
              For entertainment purposes only. DYOR!
            </span>
          ) : (
            `This site is protected by reCAPTCHA and the Google Privacy Policy and
          Terms of Service apply`
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
